import React from 'react';
import { Heading4 } from '@latitude/heading';
import { COLOR, MARGIN } from '@latitude/core/utils/constants';
import { ListNumbered } from '@latitude/list-numbered';
import { Strong } from '@latitude/text';
import data from '../../data/json/how-to-apply.json';
import HowToApply from '../HowToApply/HowToApplyKiwibank';

const HowToApplyEligibility = props => (
  <HowToApply
    id="how-to-apply"
    box1={
      <React.Fragment>
        <Heading4
          color={COLOR.BLACK}
          marginBottom={MARGIN.M16}
          isResponsive={false}
        >
          {props.title || data.title}
        </Heading4>
        <ListNumbered
          data={props.data || data.HowToApplyKiwibank}
          viewStyle="compact"
          separator="none"
          counterBgColor="#303030"
        />
      </React.Fragment>
    }
    box2={
      <React.Fragment>
        <Heading4
          color={COLOR.BLACK}
          marginBottom={MARGIN.M16}
          isResponsive={false}
        >
          Eligibility
        </Heading4>
        <Strong
          css={`
            display: block;
            margin-bottom: ${MARGIN.M8};
          `}
        >
          You must:
        </Strong>
        <ListNumbered
          viewStyle="compact"
          data={props.data || data.EligibilityKiwibank}
          separator="none"
          counterBgColor="#303030"
        />
      </React.Fragment>
    }
  />
);

export default HowToApplyEligibility;
